import { render, staticRenderFns } from "./RestaurantMenuProductsListCard.vue?vue&type=template&id=56ccace5"
import script from "./RestaurantMenuProductsListCard.vue?vue&type=script&lang=ts"
export * from "./RestaurantMenuProductsListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports